import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import { AllSelectedCandidates } from './OrgChart';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { messageService } from './_services'

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { candidates } from './data'

const useStyles = makeStyles({
    root: {
        width: "100%",
        height: 210
    },
    media: {
        //height: 80,
    },
});



export const MediaCard = ({ noImage, role, number, selectedCandidateURL }) => {
    const [name, setName] = useState("");
    let [image, setImage] = useState("whiteBG.png");
    const classes = useStyles();
    const [selectedCandidate, setSelectedCandidate] = useState("");
    let candidateSelected = false;
    if (selectedCandidateURL) {
        candidateSelected = true;
        //setImage(selectedCandidateURL.imageURL)
        image = selectedCandidateURL.imageURL
    }
    let showImage = () => {
        if (noImage) {
            return;
        } else {
            return <div>
                <img src={"./" + image} style={{
                    objectFit: "contain", /* Do not scale the image */
                    objectPosition: "center", /* Center the image within the element */
                    height: "6rem",
                    width: "100%",
                }} alt={image} />
            </div>
        }
    }
    candidateSelected = (e, v) => {
        if (v !== null) {
            setName(v.name);
            setImage(v.imageURL);

            AllSelectedCandidates[number] = parseInt(v.imageURL);
            console.log(btoa(JSON.stringify(AllSelectedCandidates)));
            console.log(atob(btoa(JSON.stringify(AllSelectedCandidates))));
            window.history.replaceState(null, "Malaysian Cabinet", process.env.PUBLIC_URL + "#/"+ btoa(JSON.stringify(AllSelectedCandidates)));

        }


    };
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <Card className={classes.root}>

                {showImage()}
                <Autocomplete
                    id="combo-box-demo"
                    size={'small'}
                    onChange={candidateSelected}
                    fullWidth={true}
                    //inputValue={selectedCandidate}
                    options={candidates}
                    getOptionLabel={(option) => option.name}
                    inputValue={candidateSelected && selectedCandidateURL?.name}
                    style={{ width: "100%" }}
                    renderInput={(params) => <TextField {...params} label="Candidate" variant="outlined" />}
                />
                <Typography variant="caption" color="textSecondary" component="p">
                    {role}
                </Typography>
                <CardContent style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    flexDirection: "column",

                }}>
                </CardContent>



            </Card>
        </div>
    );
}
